import React, { useState, useEffect } from "react";
import { X, Edit, Loader2 } from "lucide-react";
import { showToast } from "../../components/common/notification/Notification";
import { editContact } from "./networkApi";

const EditContactModal = ({ show, contact, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    id: "",
    first_name: "",
    last_name: "",
    mobile_number: "",
    email_address: "",
    address: "",
    area_name: "",
    zip_code: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (contact) {
      setFormData({
        id: contact.id,
        first_name: contact.first_name || contact.firstName || "",
        last_name: contact.last_name || contact.lastName || "",
        mobile_number: (contact.mobile_number || contact.mobileNo || "").replace(/^91/, ""),
        email_address: contact.email_address || contact.emailId || "",
        address: contact.address || "",
        area_name: contact.area_name || contact.area || "",
        zip_code: contact.zip_code || contact.zipCode || "",
      });
    }
  }, [contact]);

  if (!show || !contact) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.first_name?.trim()) {
      showToast("First Name is required", { type: "error" });
      return;
    }

    try {
      setIsSubmitting(true);
      const res = await editContact(formData);

      if (res?.statusType === "SUCCESS" || res?.status === "SUCCESS" || res?.contact) {
        showToast("Contact updated successfully", { type: "success" });
        onSuccess?.();
        onClose?.();
      } else {
        showToast(res?.text || res?.message || "Failed to update contact", { type: "error" });
      }
    } catch (err) {
      console.error("Edit contact error:", err);
      showToast(err?.response?.data?.text || "An error occurred while updating contact", {
        type: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="net-modal-overlay" onClick={onClose}>
      <div className="net-modal" onClick={(e) => e.stopPropagation()}>
        <form onSubmit={handleSubmit} className="net-modal-form">
          <div className="net-modal__header">
            <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
              <div
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "10px",
                  background: "#f0fdf4",
                  color: "#16a34a",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <Edit size={18} />
              </div>
              <div>
                <h3 className="net-modal__title">Edit Contact</h3>
                <p style={{ margin: 0, fontSize: "0.75rem", color: "#64748b" }}>
                  Update contact information
                </p>
              </div>
            </div>
            <button type="button" className="net-drawer__close" onClick={onClose}>
              <X size={18} />
            </button>
          </div>

          <div className="net-modal__body">
            <div className="net-form-grid-2">
              <div className="net-form-group">
                <label className="net-form-label">First Name *</label>
                <input
                  type="text"
                  name="first_name"
                  className="net-form-input"
                  value={formData.first_name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="net-form-group">
                <label className="net-form-label">Last Name</label>
                <input
                  type="text"
                  name="last_name"
                  className="net-form-input"
                  value={formData.last_name}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="net-form-grid-2">
              <div className="net-form-group">
                <label className="net-form-label">Mobile Number *</label>
                <input
                  type="tel"
                  name="mobile_number"
                  className="net-form-input"
                  value={formData.mobile_number}
                  onChange={handleInputChange}
                  maxLength={10}
                  required
                />
              </div>
              <div className="net-form-group">
                <label className="net-form-label">Email Address</label>
                <input
                  type="email"
                  name="email_address"
                  className="net-form-input"
                  value={formData.email_address}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="net-form-grid-2">
              <div className="net-form-group">
                <label className="net-form-label">Area / Locality</label>
                <input
                  type="text"
                  name="area_name"
                  className="net-form-input"
                  value={formData.area_name}
                  onChange={handleInputChange}
                />
              </div>
              <div className="net-form-group">
                <label className="net-form-label">Zip Code</label>
                <input
                  type="text"
                  name="zip_code"
                  className="net-form-input"
                  value={formData.zip_code}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="net-form-group">
              <label className="net-form-label">Address</label>
              <input
                type="text"
                name="address"
                className="net-form-input"
                value={formData.address}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="net-modal__footer">
            <button type="button" className="net-btn net-btn--secondary" onClick={onClose}>
              Cancel
            </button>
            <button
              type="submit"
              className="net-btn net-btn--primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <Loader2 size={16} className="net-spin" /> Saving...
                </>
              ) : (
                "Save Changes"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditContactModal;
